import { helpers } from 'vuelidate/lib/validators'
import * as countryCodes from '../types/country-code'
import moment from 'moment'

const ibanValidator = require('iban')
const countryCodePostcodeRegexMap = {}
countryCodePostcodeRegexMap[countryCodes.COUNTRY_CODE_NLD] = /^[0-9]{4}[A-Z]{2}$/
countryCodePostcodeRegexMap[countryCodes.COUNTRY_CODE_BEL] = /^[1-9]{1}[0-9]{3}$/
countryCodePostcodeRegexMap[countryCodes.COUNTRY_CODE_DEU] = /^[0-9]{5}$/

export const initials = helpers.regex('initials', /^[-A-Za-z'.]*$/)
export const surname = helpers.regex('surname', /^[-A-Za-z' ]*$/)
export const iban = (value) => !helpers.req(value) || ibanValidator.isValid(value)
export const postcode = (param) => (value) => !helpers.req(value) || countryCodePostcodeRegexMap[param].test(value)
export const streetName = helpers.regex('streetName', /^[-A-Za-z\s'.0-9]*$/)
export const cityName = helpers.regex('cityName', /^[-A-Za-z\s'.0-9]*$/)
export const countryCode = (value) => !helpers.req(value) || countryCodePostcodeRegexMap.hasOwnProperty(value)
export const password = helpers.regex('password', /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{8,32}$/)
export const date = (value) => !value || moment(value, 'DD-MM-YYYY', true).isValid()



// WEBPACK FOOTER //
// ./src/validators/index.js